import { faSpinnerThird } from '@fortawesome/duotone-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@mui/material/Button';
import type { ButtonProps } from '@mui/material/Button';
import * as React from 'react';

import Box from '~/common/components/Box';
import palette from '~/theme/mui/palette';

type MUIButtonProps = {
  isLoading?: boolean;
  isDisabled?: boolean;
} & ButtonProps;

const MUIButton = React.forwardRef<HTMLButtonElement, Readonly<MUIButtonProps>>(
  (
    {
      fullWidth = false,
      isDisabled,
      sx,
      isLoading,
      variant = 'contained',
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <Button
        ref={ref}
        disabled={isDisabled || isLoading}
        sx={{ position: 'relative', ...sx }}
        data-loading={isLoading}
        fullWidth={fullWidth}
        variant={variant}
        {...props}
      >
        {isLoading && (
          <>
            <Box
              sx={{
                position: 'absolute',
                top: '60%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              <FontAwesomeIcon
                color={palette.gray[200]}
                aria-label="loading"
                icon={faSpinnerThird}
                spin
                style={{ fontSize: '20px', animationDuration: '0.5s' }}
              />
            </Box>
            <Box sx={{ opacity: 0 }}>{children}</Box>
          </>
        )}
        {!isLoading && children}
      </Button>
    );
  },
);

export default MUIButton;
